import axios from 'axios'
import {ProductTypesQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL


const getProductTypes = (): Promise<ProductTypesQueryResponse> => {
  return axios.get(`${API_URL}/ProductTypeServlet`)
  .then( res => {
    // conform output to { data, payload } object.
    return {data : res.data , payload : {}};
  })
}

const getAllProductTypes = () => {
  return axios.get(`${API_URL}/ProductTypeServlet`).then((res) => res.data);
}

export {getProductTypes, getAllProductTypes}
